import { Transform } from 'class-transformer';

export function RemoveSpecialCharacters() {
  return Transform(data => data.value.replace(/[\W_]/g, ''))
}
